<style>
.section:hover, .validators-section:hover, .iwea-section:hover {
  border: 1px solid rgba(111, 66, 193, 0.3);
  border-radius: 8px;
  transition: border 0.2s ease;
}
</style>

<div class="page">
  <app-page-site-switcher *ngIf="false"></app-page-site-switcher>
  <div class="page-grid">
    <section class="card">
      <div class="card__body" *ngIf="!loading; else loadingTpl">
      <form *ngIf="allThresholds" (ngSubmit)="saveThresholds()" #objectifsForm="ngForm">
        <!-- Grille principale -->
        <div class="config-sections">
          <!-- Section Satisfaction & Participation -->
          <div class="section">
            <h4>{{ 'pilotage.objectifs.satisfaction.sectionTitle' | translate }}</h4>

            <label>{{ 'pilotage.objectifs.satisfaction.satisfactionLabel' | translate }} <span style="color: red;">*</span>
              <span class="info-tooltip satisfaction-tooltip">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                </svg>
              </span>
            </label>
            <div class="input-suffix">
              <input type="number" min="0" max="100" pattern="[0-9]*" required
                     [(ngModel)]="allThresholds.quality.satisfactionMinPercent" name="satisfaction" #satisfaction="ngModel">
              <span>%</span>
            </div>
            <div *ngIf="satisfaction.invalid && satisfaction.touched" style="color: red; font-size: 12px; margin-top: 4px;">
              {{ 'pilotage.objectifs.validation.requiredPercent' | translate }}
            </div>

            <label>{{ 'pilotage.objectifs.satisfaction.participationLabel' | translate }} <span style="color: red;">*</span>
              <span class="info-tooltip participation-tooltip">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                </svg>
              </span>
            </label>
            <div class="input-suffix">
              <input type="number" min="0" max="100" pattern="[0-9]*" required
                     [(ngModel)]="allThresholds.quality.qrParticipationMinPercent" name="qrParticipation" #qrParticipation="ngModel">
              <span>%</span>
            </div>
            <div *ngIf="qrParticipation.invalid && qrParticipation.touched" style="color: red; font-size: 12px; margin-top: 4px;">
              {{ 'pilotage.objectifs.validation.requiredPercent' | translate }}
            </div>

            <label>{{ 'pilotage.objectifs.satisfaction.qrScanLabel' | translate }} <span style="color: red;">*</span>
              <span class="info-tooltip qrscan-tooltip">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                </svg>
              </span>
            </label>
            <input type="number" min="0" pattern="[0-9]*" required
                   [(ngModel)]="allThresholds.quality.qrScanMinCount" name="qrScanCount" #qrScanCount="ngModel">
            <div *ngIf="qrScanCount.invalid && qrScanCount.touched" style="color: red; font-size: 12px; margin-top: 4px;">
              {{ 'pilotage.objectifs.validation.requiredPositiveInt' | translate }}
            </div>

            <div class="toggle-container">
              <label class="toggle-switch">
                <input type="checkbox" [(ngModel)]="allThresholds.quality.allowOutOfHoursComments" name="allowOutOfHours">
                <span class="toggle-label">{{ 'pilotage.objectifs.satisfaction.allowOutOfHours' | translate }}
                  <span class="info-tooltip hours-tooltip">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                    </svg>
                  </span>
                </span>
              </label>
            </div>
          </div>

          <!-- Section Performance opérationnelle -->
          <div class="section">
            <h4>{{ 'pilotage.objectifs.performance.sectionTitle' | translate }}</h4>

            <label>{{ 'pilotage.objectifs.performance.perceivedWaitLabel' | translate }} <span style="color: red;">*</span>
              <span class="info-tooltip constrained-tooltip">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                </svg>
              </span>
            </label>
            <select [(ngModel)]="allThresholds.quality.perceivedWaitThreshold" name="perceivedWait" required>
              <option value="court">{{ 'pilotage.objectifs.performance.waitShort' | translate }}</option>
              <option value="moyen">{{ 'pilotage.objectifs.performance.waitMedium' | translate }}</option>
              <option value="long">{{ 'pilotage.objectifs.performance.waitLong' | translate }}</option>
            </select>

            <label>{{ 'pilotage.objectifs.performance.complaintsCountLabel' | translate }} <span style="color: red;">*</span>
              <span class="info-tooltip contact-tooltip">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                </svg>
              </span>
            </label>
            <input type="number" min="0" max="50" pattern="[0-9]*" required
                   [(ngModel)]="allThresholds.quality.contactRequestsMaxCount" name="contactRequests" #contactRequests="ngModel">
            <div *ngIf="contactRequests.invalid && contactRequests.touched" style="color: red; font-size: 12px; margin-top: 4px;">
              {{ 'pilotage.objectifs.validation.requiredRange0to50' | translate }}
            </div>

            <label>{{ 'pilotage.objectifs.performance.responseRateLabel' | translate }} <span style="color: red;">*</span>
              <span class="info-tooltip response-tooltip">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                </svg>
              </span>
            </label>
            <div class="input-suffix">
              <input type="number" min="0" max="100" pattern="[0-9]*" required
                     [(ngModel)]="allThresholds.quality.responseRateMinPercent" name="responseRate" #responseRate="ngModel">
              <span>%</span>
            </div>
            <div *ngIf="responseRate.invalid && responseRate.touched" style="color: red; font-size: 12px; margin-top: 4px;">
              {{ 'pilotage.objectifs.validation.requiredPercent' | translate }}
            </div>
          </div>

          <!-- Section Conformité & Fiabilité -->
          <div class="section">
            <h4>{{ 'pilotage.objectifs.reliability.sectionTitle' | translate }}</h4>

            <label>{{ 'pilotage.objectifs.reliability.reliabilityLabel' | translate }} <span style="color: red;">*</span>
              <span class="info-tooltip reliability-tooltip">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                </svg>
              </span>
            </label>
            <div class="input-suffix">
              <input type="number" min="0" max="100" pattern="[0-9]*" required
                     [(ngModel)]="allThresholds.quality.reliabilityMinPercent" name="reliability" #reliability="ngModel">
              <span>%</span>
            </div>
            <div *ngIf="reliability.invalid && reliability.touched" style="color: red; font-size: 12px; margin-top: 4px;">
              {{ 'pilotage.objectifs.validation.requiredPercent' | translate }}
            </div>

            <label>{{ 'pilotage.objectifs.reliability.responseDelayLabel' | translate }} <span style="color: red;">*</span>
              <span class="info-tooltip delay-tooltip">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                </svg>
              </span>
              <span *ngIf="allThresholds.quality.responseDelayMaxMinutes" style="color: #6b7280; font-size: 12px; margin-left: 8px;">
                ({{ getFormattedDelay(allThresholds.quality.responseDelayMaxMinutes) }})
              </span>
            </label>
            <div class="input-suffix">
              <input type="number" min="0" pattern="[0-9]*" required
                     [(ngModel)]="allThresholds.quality.responseDelayMaxMinutes" name="responseDelay" #responseDelay="ngModel">
              <span>min</span>
            </div>
            <div *ngIf="responseDelay.invalid && responseDelay.touched" style="color: red; font-size: 12px; margin-top: 4px;">
              {{ 'pilotage.objectifs.validation.requiredPositiveInt' | translate }}
            </div>

            <label>{{ 'pilotage.objectifs.reliability.actionCountLabel' | translate }} <span style="color: red;">*</span>
              <span class="info-tooltip action-tooltip">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                </svg>
              </span>
            </label>
            <input type="number" min="0" pattern="[0-9]*" required
                   [(ngModel)]="allThresholds.quality.actionCount" name="actionCount" #actionCount="ngModel">
            <div *ngIf="actionCount.invalid && actionCount.touched" style="color: red; font-size: 12px; margin-top: 4px;">
              {{ 'pilotage.objectifs.validation.requiredPositiveInt' | translate }}
            </div>
          </div>

          <!-- Module Validateurs -->
          <div class="validators-section" *ngIf="allThresholds">
          <div class="section-header">
            <h4>{{ 'pilotage.objectifs.validators.sectionTitle' | translate }}
              <span class="info-tooltip validators-header-tooltip">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                </svg>
              </span>
            </h4>
            <button type="button" class="btn-add" (click)="addValidator()" *ngIf="!allThresholds.documentValidators || allThresholds.documentValidators.length < 3">✚ {{ 'pilotage.objectifs.validators.add' | translate }}</button>
            <span *ngIf="allThresholds.documentValidators && allThresholds.documentValidators.length >= 3" style="color: #666; font-size: 14px;">{{ 'pilotage.objectifs.validators.maxReached' | translate }}</span>
          </div>

          <div class="validators-list" *ngIf="allThresholds.documentValidators && allThresholds.documentValidators.length > 0; else noValidators">
            <div class="validator-header">
              <span class="field-order">#</span>
              <span class="field-drag">⋮⋮</span>
              <div class="validator-fields">
                <span class="field-small">{{ 'pilotage.objectifs.validators.civility' | translate }}</span>
                <span class="field-medium">{{ 'pilotage.objectifs.validators.fullName' | translate }} <span style="color: red;">*</span></span>
                <span class="field-medium">{{ 'pilotage.objectifs.validators.role' | translate }} <span style="color: red;">*</span></span>
              </div>
              <span class="header-spacer"></span>
            </div>
            <div class="validator-item" *ngFor="let validator of allThresholds.documentValidators; let i = index; trackBy: trackValidator"
                 draggable="true"
                 (dragstart)="onDragStart($event, i)"
                 (dragend)="onDragEnd($event)"
                 (dragover)="onDragOver($event)"
                 (dragenter)="onDragEnter($event)"
                 (dragleave)="onDragLeave($event)"
                 (drop)="onDrop($event, i)"
                 style="transition: all 0.2s ease;">
              <span class="field-order">{{i + 1}}</span>
              <span class="field-drag" style="cursor: grab;">⋮⋮</span>
              <div class="validator-fields">
                <select [(ngModel)]="validator.civility" [name]="'civility'+i" class="field-small">
                  <option value="M.">M.</option>
                  <option value="Mme">Mme</option>
                  <option value="Mr">Mr</option>
                  <option value="Dr">Dr</option>
                  <option [value]="null">-</option>
                </select>

                <input type="text" [(ngModel)]="validator.fullName" [name]="'fullName'+i" [placeholder]="'pilotage.objectifs.validators.fullName' | translate" class="field-medium" required>

                <input type="text" [(ngModel)]="validator.roleLabel" [name]="'roleLabel'+i" [placeholder]="'pilotage.objectifs.validators.role' | translate" class="field-medium" required>
              </div>

              <button type="button" class="btn-danger-chip" (click)="removeValidator(i)" [disabled]="allThresholds.documentValidators.length <= 1">
                <img class="icon-16" src="/assets/delete.svg" [attr.alt]="'pilotage.objectifs.validators.delete' | translate" />
              </button>
            </div>
          </div>

          <ng-template #noValidators>
            <p class="no-validators">{{ 'pilotage.objectifs.validators.none' | translate }}</p>
          </ng-template>

          <div *ngIf="allThresholds.documentValidators && allThresholds.documentValidators.length === 0" style="margin-top: 10px;">
            <button type="button" class="btn-add" (click)="addValidator()">✚ {{ 'pilotage.objectifs.validators.addFirst' | translate }}</button>
          </div>
        </div>

          <!-- Bouton en bas -->
          <div class="button-section">
            <button type="submit" class="btn-primary" [disabled]="saving || objectifsForm.invalid">
              {{ (saving ? 'pilotage.objectifs.saving' : 'pilotage.objectifs.saveThresholds') | translate }}
            </button>
          </div>
        </div>
      </form>

      <div *ngIf="!allThresholds" class="wizard-invitation">
        <div class="wizard-icon">⚙️</div>
        <h3>{{ 'pilotage.objectifs.configRequired.title' | translate }}</h3>
        <p>{{ 'pilotage.objectifs.configRequired.body' | translate }}</p>
      </div>
      </div>
    </section>

    <!-- Seuils d'affluence : Fluide / Modéré / Forte affluence -->
    <section class="card" style="margin-top:16px">
      <div class="card__body">
        <h4 style="margin-top:0">{{ 'pilotage.objectifs.affluence.sectionTitle' | translate }}</h4>
        <p style="color:#6b7280;font-size:13px;margin-top:-8px">
          {{ 'pilotage.objectifs.affluence.sectionHint' | translate }}
        </p>

        <div class="loading" *ngIf="loadingAffluence">{{ 'pilotage.objectifs.affluence.loading' | translate }}</div>

        <ng-container *ngIf="!loadingAffluence && orgDefaultThresholds">
          <!-- Défaut organisation -->
          <div class="section">
            <h4>{{ 'pilotage.objectifs.affluence.orgDefaultTitle' | translate }}</h4>

            <div style="display:flex;gap:16px;flex-wrap:wrap">
              <div>
                <label>{{ 'pilotage.objectifs.affluence.thresholdLowLabel' | translate }}</label>
                <div class="input-suffix">
                  <input type="number" min="0" [(ngModel)]="orgDefaultThresholds.waitLowMinutes" name="orgWaitLow">
                  <span>min</span>
                </div>
              </div>
              <div>
                <label>{{ 'pilotage.objectifs.affluence.thresholdHighLabel' | translate }}</label>
                <div class="input-suffix">
                  <input type="number" min="0" [(ngModel)]="orgDefaultThresholds.waitHighMinutes" name="orgWaitHigh">
                  <span>min</span>
                </div>
              </div>
            </div>

            <div class="button-section">
              <button type="button" class="btn-primary" [disabled]="savingOrgDefault" (click)="saveOrgDefaultThresholds()">
                {{ (savingOrgDefault ? 'pilotage.objectifs.affluence.saving' : 'pilotage.objectifs.affluence.saveDefault') | translate }}
              </button>
            </div>
          </div>

          <!-- Surcharge pour le site sélectionné -->
          <div class="section">
            <h4>{{ 'pilotage.objectifs.affluence.customizeForSite' | translate: { site: currentEstablishmentName } }}</h4>

            <p *ngIf="!customizeForSite" style="color:#6b7280;font-size:13px">
              {{ 'pilotage.objectifs.affluence.usingOrgDefault' | translate }}
            </p>
            <button type="button" class="btn-add" *ngIf="!customizeForSite" (click)="startCustomizeForSite()">✚ {{ 'pilotage.objectifs.affluence.customizeButton' | translate }}</button>

            <ng-container *ngIf="customizeForSite && estOverrideThresholds">
              <div style="display:flex;gap:16px;flex-wrap:wrap;margin-top:8px">
                <div>
                  <label>{{ 'pilotage.objectifs.affluence.thresholdLowLabel' | translate }}</label>
                  <div class="input-suffix">
                    <input type="number" min="0" [(ngModel)]="estOverrideThresholds.waitLowMinutes" name="estWaitLow">
                    <span>min</span>
                  </div>
                </div>
                <div>
                  <label>{{ 'pilotage.objectifs.affluence.thresholdHighLabel' | translate }}</label>
                  <div class="input-suffix">
                    <input type="number" min="0" [(ngModel)]="estOverrideThresholds.waitHighMinutes" name="estWaitHigh">
                    <span>min</span>
                  </div>
                </div>
              </div>

              <div class="button-section" style="display:flex;gap:10px">
                <button type="button" class="btn-primary" [disabled]="savingEstOverride" (click)="saveEstOverrideThresholds()">
                  {{ (savingEstOverride ? 'pilotage.objectifs.affluence.saving' : 'pilotage.objectifs.affluence.saveForSite') | translate }}
                </button>
                <button type="button" class="btn-add" *ngIf="hasEstOverride" [disabled]="clearingEstOverride" (click)="clearEstOverrideThresholds()">
                  {{ clearingEstOverride ? '...' : ('pilotage.objectifs.affluence.backToDefault' | translate) }}
                </button>
                <button type="button" class="btn-add" *ngIf="!hasEstOverride" (click)="cancelCustomizeForSite()">{{ 'pilotage.objectifs.affluence.cancel' | translate }}</button>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </section>
  </div>

  <ng-template #loadingTpl>
    <div class="loading">{{ 'pilotage.objectifs.affluence.loadingThresholds' | translate }}</div>
  </ng-template>
</div>
